export default {
  SET_FILE_SERVERS: 'setFileServers',
  SET_SELECTED_FILE_SERVER: 'setSelectedFileServer',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal',
}